import * as React from 'react';
import { flow } from 'lodash';
import { Button, Modal } from 'react-bootstrap';
import UpdateCardModalForm from './UpdateCardModalForm';
import {actions as authActions, IAuthActions} from '../../../../services/auth/reducer';
import {formValueSelector, reduxForm, submit} from 'redux-form';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import {IAuthState} from '../../../../services/auth/models';
import {push} from 'react-router-redux';
import {actions as quoteActions} from '../../../../services/quote/reducer';

interface IUpdateCardModalProps {
  auth: IAuthState;
  actions: {
    submit(name: string);
    push(path: string);
    auth: IAuthActions;
  };
}

interface IUpdateCardModalStates {
  isSaved: boolean;
  showModal: boolean;
  isSubmitting: boolean;
}

class UpdateCardModal extends React.Component<IUpdateCardModalProps, IUpdateCardModalStates> {
  public state = {
    isSubmitting: false,
    isSaved: false,
    showModal: false,
  };

  private openModal = () => {
    this.setState({
      showModal: true,
    });
  }

  private handleSubmit = (values) => {
    const { actions } = this.props;

    this.setState({
      isSubmitting: true,
    });

    actions.auth.updateCustomerCard(values).then((response) => {
      this.setState({
        isSaved: true,
        isSubmitting: false,
      });
    });
  }

  private handleCloseModal = () => {
    const { dispatch, reset } = this.props;

    this.setState({
      showModal: false,
      isSaved: false,
      isSubmitting: false,
    });

    dispatch(reset('customer1'));
  }

  public render() {
    const { showModal, isSaved, isSubmitting } = this.state;

    return (
      <span>
        <Button
          className={'btn-secondary pull-right red'}
          onClick={this.openModal}
        >
            Mettre à jour mes coordonnées bancaires
        </Button>

        <Modal show={showModal} onHide={this.handleCloseModal} >
          <Modal.Header closeButton={true}>
            <Modal.Title>Mise á jour</Modal.Title>
          </Modal.Header>
          <UpdateCardModalForm
            onSubmit={this.handleSubmit}
            onCloseModal={this.handleCloseModal}
            isSaved={isSaved}
            isSubmitting={isSubmitting}
          />
        </Modal>
      </span>
    );
  }
}

let selector;

export default flow([
  reduxForm({
    form: 'customer1',
    destroyOnUnmount: false,
    forceUnregisterOnUnmount: true,
  }),
  (component) => {
    selector = formValueSelector('customer1');

    return component;
  },
  connect(
    (state) => {
      return {
        auth: state.auth,
        quote: state.quote,
      };
    },
    (dispatch) => ({
      actions: {
        push: bindActionCreators(push, dispatch),
        submit: bindActionCreators(submit, dispatch),
        auth: bindActionCreators({ ...authActions }, dispatch),
        quote: bindActionCreators({...quoteActions}, dispatch),
        dispatch,
      },
    }),
  ),
])(UpdateCardModal);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/scenes/CustomerArea/scenes/UpdateCardModal/index.tsx